/**
 * @fileoverview POST handler for the "/generative_ai/brand_guidelines" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiBrandGuidelinesCacheKeys } from "./constants";
import type { PostGenerativeAiBrandGuidelinesProps, GenerativeAiBrandGuidelinesResult } from "./types";

export const postGenerativeAiBrandGuidelines = reactQueryMutationAdapter(
  generativeAiBrandGuidelinesCacheKeys,
  (props: PostGenerativeAiBrandGuidelinesProps): Promise<GenerativeAiBrandGuidelinesResult> => {
    return fetch("/generative_ai/brand_guidelines", "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
